export const JOB_ACTIVE_STATUS = 'Active'
export const JOB_SUSPENDED_STATUS = 'Suspended'
export const JOB_PENDING_STATUS = 'Pending'
export const JOB_UPGRADE_STATUS = 'Upgrade'
export const JOB_CLOSED_STATUS = 'Closed'
export const JOB_PENDING_REVIEW_STATUS = 'Pending Review'

export const JOB_APPROVAL_SUB_TYPE_CHANGE_ADDRESS = 'Change of Address'

export const JOB_APPROVAL_RECORD_TYPE_NEW_ADDRESS = 'New Address Approval'